import { FormattedCurrency } from '@iwIntlProvider/FormattedCurrency';
import { GetDrawDownRepaymentScheduleCreditFacilityResponse } from '@iwoca/lapi-client/edge';
import { Text } from '@iwoca/orion';
import { FormattedMessage } from 'react-intl';

import { PaymentPlanSchedule } from './PaymentPlanSchedule';

export const RCFRepaymentSchedule = ({
    newOutstandingBalance,
    repaymentSchedule,
    isInRepaymentFreePeriod
}: {
    newOutstandingBalance: number;
    repaymentSchedule: GetDrawDownRepaymentScheduleCreditFacilityResponse['data'];
    isInRepaymentFreePeriod?: boolean;
}) => {
    return (
        <div className="space-y-m">
            <div>
                <h3 className="mb-s mt-s text-2xl font-bold">
                    <FormattedMessage
                        id="_.rcf_approved_view.payment_plan_modal_title"
                        defaultMessage="Indicative payment plan"
                    />
                </h3>
                <Text data-testid="repayment-schedule-description">
                    <FormattedMessage
                        id="_.rcf_approved_view.repayment_schedule_description"
                        defaultMessage="*assuming your outstanding loan amount is {newOutstandingBalance}. The plan updates each time you withdraw or repay money."
                        values={{
                            newOutstandingBalance: (
                                <FormattedCurrency
                                    value={newOutstandingBalance}
                                    decimalPlaces={0}
                                />
                            )
                        }}
                    />
                </Text>
            </div>
            <PaymentPlanSchedule
                repaymentSchedule={repaymentSchedule}
                isInRepaymentFreePeriod={isInRepaymentFreePeriod}
            />
        </div>
    );
};
